import { Box, Divider } from '@material-ui/core';
import React, { ReactElement } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';

import { DialogWindow, DialogWindowHeader, SmallMapCard } from '..';
import { SelectedProject, SelectedComparison } from '../../../redux';

import './selected-projects-dialog.styles.scss';
import { useTranslation } from 'react-i18next';

export interface ISelectedProjectsDialogProps {
	open: boolean;
	selectedProjects: SelectedProject[];
	selectedComparisons: SelectedComparison[];
	deselectProject: (project: SelectedProject) => void;
	deselectComparison: (comparison: SelectedComparison) => void;
	onClose: () => void;
}

export function SelectedProjectsDialog(
	props: ISelectedProjectsDialogProps
): ReactElement {
	const {
		open,
		selectedProjects,
		selectedComparisons,
		deselectProject,
		onClose,
		deselectComparison
	} = props;

	const { t } = useTranslation('myBosatlas');

	return (
		<DialogWindow
			className="selected-projects-dialog"
			open={open}
			onClose={onClose}
		>
			<DialogWindowHeader
				title={t('folder.mapsWantToAdd')}
				onClose={onClose}
			/>
			<Box className="selected-projects-container">
				{selectedProjects.map(
					(selectedProject: SelectedProject, index: number) => (
						<Box key={selectedProject.id}>
							<SmallMapCard
								thumbnailSrc={selectedProject.thumbnail}
								title={selectedProject.title}
								onIconClick={() =>
									deselectProject(selectedProject)
								}
								iconButtonIcon={<DeleteIcon color="primary" />}
							/>
							{(index < selectedProjects.length - 1 ||
								selectedComparisons.length > 0) && <Divider />}
						</Box>
					)
				)}
				{selectedComparisons.map(
					(selectedComparison: SelectedComparison, index: number) => (
						<Box key={selectedComparison.id}>
							<SmallMapCard
								comparison={selectedComparison}
								onIconClick={() =>
									deselectComparison(selectedComparison)
								}
								iconButtonIcon={
									<DeleteIcon htmlColor="#CF0101" />
								}
							/>
							{index < selectedComparisons.length - 1 && (
								<Divider />
							)}
						</Box>
					)
				)}
			</Box>
		</DialogWindow>
	);
}
